import { io } from "socket.io-client";
import config from "../config"

const API_URL = config.API_BASE_URL || process.env.REACT_APP_API_URL || "http://localhost:5002";
const SOCKET_URL = API_URL.replace(/\/api\/v1\.0\/?$/, "");

// Create the socket instance (do not connect yet)
const socket = io(SOCKET_URL, {
  autoConnect: false,                // we’ll connect after getting the token
  auth: {
    token: null,
  },
});

// Function to set the token and connect
export function connectSocket(userToken, userId) {
  socket.auth.token = userToken;
  socket.connect();

  socket.on("connect", () => {
    // Register the user so the backend can map user -> room
    socket.emit("register", userId);
  });

  socket.on("connect_error", (error) => {
    console.error("Socket connection error:", error);
  });

  return socket;
}

// Export the socket instance for use in components
export default socket;